<template>
  <div class="topbar">
    <v-container fluid class="topbar-wrapper">
      <v-row>
        <v-col>
          <div class="topbar-branding">
            <img
              class="topbar-branding-logo"
              src="@/assets/img/logo_etat_fribourg.svg"
            />
          </div>
        </v-col>
      </v-row>
    </v-container>
    <v-container fluid class="topbar-fixed">
      <v-row>
        <v-col>
          <div class="topbar-main">
            <div class="topbar-navigation d-none d-md-block">
              <base-button
                v-if="isHome"
                v-scroll-to="'body'"
                navigation
                color="color-1"
              >
                {{ $t('topbar.home') }}
              </base-button>
              <base-button
                v-else
                @click.native="$router.push({ name: 'Home' })"
                navigation
                color="color-1"
              >
                {{ $t('topbar.home') }}
              </base-button>
              <base-button
                v-if="isHome"
                v-scroll-to="'.congratulations'"
                navigation
                color="color-2"
              >
                {{ $t('topbar.graduates') }}
              </base-button>
              <base-button
                v-else
                @click.native="
                  $router.push({ name: 'Home', hash: '#laureats' })
                "
                navigation
                color="color-2"
              >
                {{ $t('topbar.graduates') }}
              </base-button>
              <base-button
                v-if="isLogged && isHome && 1 === 1"
                @click.native="$router.push({ name: 'Identity' })"
                navigation
                color="color-4"
              >
                {{ $t('register.topbar.edit') }}
              </base-button>
              <base-button
                v-if="isLogged && !isHome && 1 === 1"
                @click.native="logout"
                navigation
                color="color-4"
              >
                {{ $t('register.topbar.logout') }}
              </base-button>
            </div>
            <div class="topbar-language d-none d-md-block">
              <base-button
                language
                color="color-3"
                @click.native="changeLanguage('de')"
                >De</base-button
              >
              <base-button
                language
                color="color-4"
                @click.native="changeLanguage('fr')"
                >Fr</base-button
              >
            </div>
            <a
              href="#"
              @click.prevent="$emit('toggleDrawer')"
              :class="`topbar-burger d-md-none${isOpen ? ' is-open' : ''}`"
            >
              <div class="topbar-burger-inner"></div>
            </a>
          </div>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import BaseButton from '@/components/BaseButton'

import { Trans } from '@/plugins/i18n'

export default {
  props: {
    isOpen: Boolean
  },
  computed: {
    isHome() {
      return this.$route.name === 'Home'
    },
    isLogged() {
      return this.$store.getters['auth/isLogged']
    }
  },
  methods: {
    changeLanguage(language) {
      Trans.changeLanguage(language)
    },
    logout() {
      this.$store.dispatch('auth/logout').then(() => location.reload())
    }
  },
  components: {
    BaseButton
  }
}
</script>

<style lang="scss">
@import '~vuetify/src/styles/styles.sass';

.topbar {
  pointer-events: none;
}

.topbar-wrapper {
  position: absolute;
  top: 0;
  right: 0;
  left: 0;
  z-index: 10;
}

.topbar-fixed {
  position: fixed;
  top: 0;
  right: 0;
  left: 0;
  z-index: 10;
}

.topbar-branding {
  pointer-events: none;
}

.topbar-branding-logo {
  width: 105px;
  margin-left: 12px;

  @media #{map-get($display-breakpoints, 'sm-and-down')} {
    width: 60px;
    margin-left: 0;
  }
}

.topbar-main {
  display: flex;
  justify-content: flex-end;
}

.topbar-navigation {
  margin-right: 127px;
  pointer-events: all;
}

.topbar-language {
  margin-right: 12px;
  pointer-events: all;
}

.topbar-burger {
  position: relative;
  display: inline-block;
  width: 30px;
  height: 20px;
  pointer-events: all;
}

.topbar-burger-inner {
  position: absolute;
  width: 30px;
  height: 2px;
  bottom: 0;

  background-color: #000;

  transition-delay: 0.13s;
  transition-timing-function: cubic-bezier(0.55, 0.055, 0.675, 0.19);
  transition-duration: 0.13s;

  &::before {
    @extend .topbar-burger-inner;

    content: '';
    top: -8px;
    transition: top 0.12s cubic-bezier(0.33333, 0.66667, 0.66667, 1) 0.2s,
      transform 0.13s cubic-bezier(0.55, 0.055, 0.675, 0.19);
  }

  &::after {
    @extend .topbar-burger-inner;

    content: '';
    top: -16px;
    transition: top 0.2s cubic-bezier(0.33333, 0.66667, 0.66667, 1) 0.2s,
      opacity 0.1s linear;
  }
}

.topbar-burger.is-open {
  .topbar-burger-inner {
    transition-delay: 0.22s;
    transition-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);
    transform: translate3d(0, -10px, 0) rotate(-45deg);
    background: #bcfb4f;

    &::before {
      top: 0;
      transition: top 0.1s cubic-bezier(0.33333, 0, 0.66667, 0.33333) 0.16s,
        transform 0.13s cubic-bezier(0.215, 0.61, 0.355, 1) 0.25s;
      transform: rotate(-90deg);
      background: #bcfb4f;
    }

    &::after {
      top: 0;
      transition: top 0.2s cubic-bezier(0.33333, 0, 0.66667, 0.33333),
        opacity 0.1s linear 0.22s;
      transform: none;
      opacity: 0;
    }
  }
}
</style>
